import { CancelablePromise, OpenAPI, Response } from "@/api";
import { request as __request } from "@/api/core/request";
import { TemplateAddRequest } from "@/api/models/template/TemplateAddRequest";
import { ListRequest } from "@/api/models/ListRequest";
import { ToDeleteRequest } from "@/utils/slice";
import { TemplateListResponse } from "@/api/models/template/TemplateListResponse";
import { TemplateUpdateRequest } from "@/api/models/template/TemplateUpdateRequest";

export class TemplateService {
  public static Add(body: TemplateAddRequest): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/admin/letter/template",
      body: body,
    });
  }

  public static ListAll(
    body: ListRequest
  ): CancelablePromise<TemplateListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/letter/template",
      body: body,
    });
  }

  public static Update(
    body: TemplateUpdateRequest
  ): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/admin/letter/template",
      body: body,
    });
  }

  public static Delete(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/letter/template",
      body: ToDeleteRequest(body),
    });
  }

  public static Drop(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/letter/template/drop",
      body: ToDeleteRequest(body),
    });
  }
}
